/* Polyfill para entornos donde crypto.randomUUID no está disponible en contexto no-seguro (HTTP en LAN móvil) */
const nativeRandomUUID = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID.bind(crypto)
    : null;

export function safeRandomUUID(): `${string}-${string}-${string}-${string}-${string}` {
    if (nativeRandomUUID) {
        return nativeRandomUUID();
    }
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
        const buf = new Uint8Array(16);
        crypto.getRandomValues(buf);
        buf[6] = (buf[6] & 0x0f) | 0x40; // versión 4
        buf[8] = (buf[8] & 0x3f) | 0x80; // variante RFC4122
        const hex = Array.from(buf, b => b.toString(16).padStart(2, '0')).join('');
        return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}` as `${string}-${string}-${string}-${string}-${string}`;
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    }) as `${string}-${string}-${string}-${string}-${string}`;
}

if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
    try {
        Object.defineProperty(crypto, 'randomUUID', {
            value: safeRandomUUID,
            configurable: true,
            writable: true,
        });
    } catch {
        (crypto as any).randomUUID = safeRandomUUID;
    }
}

